
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import getSymbolFromCurrency from 'currency-symbol-map';
import PriceField from "./page-components/PriceField";
import UnitField from "./page-components/UnitField";
import { GetCurrencyCode } from "../../../Utils/GetData";

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
    overflowX: 'auto',
  },
  table: {
    minWidth: 650,
  },
}));



export default function SimpleTable(props) {
  const {Quotedata, SaveNewQuoteData, user_type} = props
  const rows = Quotedata.medicine_list
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Product</TableCell>
            <TableCell align="right">Brand Name</TableCell>
            <TableCell align="right">Composition</TableCell>
            <TableCell align="right">Manufacturer</TableCell>
            <TableCell align="center">Price ({getSymbolFromCurrency(GetCurrencyCode())})</TableCell>
            <TableCell align="center">Quantity</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>
              <TableCell component="th" scope="row">
                {row.medicine && row.medicine.name}
              </TableCell>
              <TableCell align="right">{row.medicine && row.medicine.name}</TableCell>
              <TableCell align="right">{row.medicine && row.medicine.composition}</TableCell>
              <TableCell align="right">{row.medicine && row.medicine.manufacturer}</TableCell>
              <TableCell align="center">
                <PriceField row={row} rows={rows} Quotedata={Quotedata} index={index} SaveNewQuoteData={SaveNewQuoteData} user_type={user_type} />
                </TableCell>
              <TableCell align="center">
                <UnitField row={row} rows={rows} Quotedata={Quotedata} index={index} SaveNewQuoteData={SaveNewQuoteData} user_type={user_type} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}
